export default {
  'insurers.filters.active': 'Ativo',
  'insurers.filters.active.options.active': 'Ativo',
  'insurers.filters.active.options.inactive': 'Inativo',
  'insurers.filters.cnpj': 'CNPJ',
  'insurers.filters.fantasyName': 'Nome fantasia',
  'insurers.filters.order': 'Ordenar por',
  'insurers.filters.order.options.asc': 'Ascendente',
  'insurers.filters.order.options.desc': 'Descendente',
  'insurers.list.header.cnpj': 'CNPJ',
  'insurers.list.header.name': 'Nome',
  'insurers.list.header.fantasyName': 'Nome Fantasia',
  'insurers.list.header.email': 'E-mail',
  'insurers.list.header.phone': 'Telefone',
  'insurers.list.header.actions': 'Ações',
  'insurers.list.column.actions.button': 'Ver/Editar',
  'insurers.searchBar.generateReport': 'Gerar relatório',
  'insurers.searchBar.button': 'Nova seguradora',
  'insurers.general.form.name': 'Nome',
  'insurers.general.form.fantasyName': 'Nome fantasia',
  'insurers.general.form.cnpj': 'CNPJ',
  'insurers.general.form.stateRegistration': 'Inscrição estadual',
  'insurers.general.form.cityRegistration': 'Inscrição municipal',
  'insurers.general.form.email': 'E-mail',
  'insurers.general.form.refactoringMargin': '(%) Margem de refatoramento',
  'insurers.general.form.website': 'Website',
  'insurers.general.form.observation': 'Observações',
  'insurers.create.notification.success': 'Seguradora criada com sucesso!',
  'insurers.create.notification.successDescription':
    'A nova seguradora foi cadastrada com sucesso!',
  'insurers.update.notification.success': 'Sucesso!',
  'insurers.update.notification.successDescription':
    'Seguradora atualizada com sucesso!',
  'insurers.remove.modal.title': 'Excluir seguradora',
  'insurers.remove.modal.content': 'Deseja realmente excluir a seguradora',
  'insurers.remove.modal.button.ok': 'Remover',
  'insurers.remove.notification.success': 'Sucesso!',
  'insurers.remove.notification.successDescription':
    'Seguradora removida com sucesso!',
  'insurers.activate.message.success': 'Seguradora ativada com sucesso!',
  'insurers.inactivate.message.success': 'Seguradora inativada com sucesso!',

  'insurers.contacts.list.header.contactType': 'Tipo do contato',
  'insurers.contacts.list.header.value': 'Contato',
  'insurers.contacts.list.header.name': 'Nome',
  'insurers.contacts.list.header.actions': 'Ações',
  'insurers.contacts.list.actions.buttons': 'Editar',
  'insurers.contacts.list.actions.buttons.remove': 'Excluir',
  'insurers.contacts.contactTypes.email': 'E-mail',
  'insurers.contacts.contactTypes.mobile': 'Celular',
  'insurers.contacts.contactTypes.fax': 'Fax',
  'insurers.contacts.contactTypes.phone': 'Telefone',
  'insurers.contacts.contactTypes.whatsapp': 'WhatsApp',
  'insurers.contacts.modal.create.title': 'Novo contato',
  'insurers.contacts.modal.update.title': 'Editar contato',
  'insurers.contacts.modal.okText': 'Salvar contato',
  'insurers.contacts.modal.cancelText': 'Cancelar',
  'insurers.contacts.remove.modal.title': 'Excluir contato',
  'insurers.contacts.remove.modal.content':
    'Deseja realmente excluir esse contato?',
  'insurers.contacts.remove.modal.okText': 'Excluir contato',
  'insurers.contacts.create.notification.success':
    'Contato criado com sucesso!',
  'insurers.contacts.create.notification.successDescription':
    'O novo contato foi criado com sucesso.',
  'insurers.contacts.update.notification.success':
    'Contato atualizado com sucesso!',
  'insurers.contacts.update.notification.successDescription':
    'O contato foi atualizado com sucesso.',
  'insurers.contacts.remove.notification.success':
    'Contato removido com sucesso!',
  'insurers.contacts.remove.notification.successDescription':
    'O contato foi removido com sucesso.',

  'insurers.addresses.list.header.zipCode': 'CEP',
  'insurers.addresses.list.header.cityId': 'Cidade',
  'insurers.addresses.list.header.street': 'Logradouro',
  'insurers.addresses.list.header.number': 'Número',
  'insurers.addresses.list.header.main': 'Endereço principal',
  'insurers.addresses.list.header.actions': 'Ações',
  'insurers.addresses.list.actions.buttons': 'Editar',
  'insurers.addresses.list.actions.buttons.remove': 'Excluir',
  'insurers.addresses.modal.create.title': 'Novo endereço',
  'insurers.addresses.modal.update.title': 'Editar endereço',
  'insurers.addresses.modal.okText': 'Salvar endereço',
  'insurers.addresses.modal.cancelText': 'Cancelar',
  'insurers.addresses.form.cityId': 'Cidade',
  'insurers.addresses.form.complement': 'Complemento',
  'insurers.addresses.form.delivery': 'Usar para entrega?',
  'insurers.addresses.form.description': 'Descrição',
  'insurers.addresses.form.id': 'Estado',
  'insurers.addresses.form.main': 'Endereço principal?',
  'insurers.addresses.form.number': 'Número',
  'insurers.addresses.form.street': 'Logradouro',
  'insurers.addresses.form.district': 'Bairro',
  'insurers.addresses.form.zipCode': 'CEP',
  'insurers.addresses.remove.modal.title': 'Excluir endereço',
  'insurers.addresses.remove.modal.content':
    'Deseja realmente excluir esse endereço?',
  'insurers.addresses.remove.modal.okText': 'Excluir endereço',
  'insurers.addresses.create.notification.success':
    'Endereço criado com sucesso!',
  'insurers.addresses.create.notification.successDescription':
    'O novo endereço foi criado com sucesso.',
  'insurers.addresses.update.notification.success':
    'Endereço atualizado com sucesso!',
  'insurers.addresses.update.notification.successDescription':
    'O endereço foi atualizado com sucesso.',
  'insurers.addresses.remove.notification.success':
    'Endereço removido com sucesso!',
  'insurers.addresses.remove.notification.successDescription':
    'O endereço foi removido com sucesso.',

  'insurers.modal.selectedInsurers.title.add': 'Adicionar Seguradora',
  'insurers.modal.selectedInsurers.search': 'Busque as seguradoras',
};
